export default {
  namespaced: true,
  state: {
    registrosSelecionados: [] 
  },
  getters: {
    getRegistrosSelecionados: (state) => state.registrosSelecionados
  },
  mutations: {
    UPDATE_LOTE_REGISTROS_SELECIONADOS (state, status) {
      state.registrosSelecionados = status
    }
  },
  actions: {
    updateLoteRegistrosSelecionados ({ commit }, status) {
      commit('UPDATE_LOTE_REGISTROS_SELECIONADOS', status)
    }
  }
}
